import _ from "lodash";
import React ,{Suspense ,useCallback}from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Moment from "moment";
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";
import { graphql } from 'babel-plugin-relay/macro';
import { useLazyLoadQuery } from 'react-relay';
import {  ViewJob_getLogJobQuery } from './__generated__/ViewJob_getLogJobQuery.graphql';
import EditJobModal from './EditJobModal'
import  { Toaster } from "react-hot-toast";
import Breadcrumb from "../Common/Breadcrumb";
import { IconPickerItem } from "react-fa-icon-picker";
import { getNoteCategories } from "../../models/_noteCategories";
export const getLogJobListById = graphql`
query ViewJob_getLogJobQuery($id:String!){
  getLogJob(id:$id){
    id
    uuid
    jobType
    locationId
     additionalNoteCategoryId
    actionNoteCategoryId
    location {
    id
    uuid
    name
    servicePlan{
      id
      indicater
     }
    }
    dateAndTime
      attachments 
      machineChecks {
        locationId
        machineId
        checksDetail
        machineName
        serialNumber
        blenderName
        tubeShieldName
        cupHolderName
      }
      tickets {
        id
        uuid
        reportedAt
        machine {
          id
          name
          serialNumber
        }
        issuesReported {
          id
          name
        }
        diagnosisDone {
          id
          name
        }
        machineServicesDone {
          id
          name
        }
      }
      operations {
        id
        name
      }
    uploadImagesOrVideos {
      url
      type
    }
    marketingMaterials {
      id
      name
    }
    sanitizerStatus
    machineSerialNumber
    machineName
    additionalComments
    actionItems
    customerSatisfaction
    cleanliness
    trafficRate
    staffEnthusiasm
    status
    closingDateAndTime
    travelTime
     travelingStartTime
    travelingEndTime
    workStartTime
    createdBy {
      id
      firstName
    }
  }
}
`

export const ViewJob = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [logjob, setLogjob] = React.useState<any>({});
  const [categoriesDB, setCategoriesDB] = React.useState<any[]>([]);
  const [editJobModal, setEditJobModal] = React.useState(false);
  const [refreshedQueryOptions, setRefreshedQueryOptions] = React.useState<any>(null);
 console.log(logjob);
 
  const splittedRoute = location.pathname.split("/").reverse()[0];
  if (!splittedRoute) {
    navigate("/job/list");
  }
  const travelingDuration = (start: string, end: string): string => {
    if (!start || !end) return "";
    const diff = new Date(end).getTime() - new Date(start).getTime();
  const hours = String(Math.floor(diff / 3600000)).padStart(2, "0");
  const minutes = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
  const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
  };
  
    const startTime = logjob?.workStartTime ? Moment.utc(logjob?.workStartTime)
    .local()
    .format("YYYY-MM-DD HH:mm:ss") : "";
    const endTime = logjob.closingDateAndTime
    ? Moment.unix(logjob.closingDateAndTime / 1000)
        .local()
        .format("YYYY-MM-DD HH:mm:ss")
    : "";
  const JobRecord = useLazyLoadQuery<ViewJob_getLogJobQuery>(
    getLogJobListById,
  {
    id:splittedRoute ?? ""
  },refreshedQueryOptions ?? {})
  const result = JobRecord?.getLogJob ?? []

  let currentJobId = result?.id

  const fetchData = async () => {
    try {
      const category = await getNoteCategories();
      setCategoriesDB(category);
      if (result === null) {
        navigate("/job/list");
      } else {
        setLogjob(result);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const refresh = useCallback(() => {
    setRefreshedQueryOptions((prev: any) => ({
      fetchKey: (prev?.fetchKey ?? 0) + 1,
      fetchPolicy: "network-only",
    }));
  }, []);

  const handleCloseJob= () => {
    setEditJobModal(false)
    refresh()
  }
  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);


  return (
    <Suspense>
    <div>
      <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
          style={{ maxWidth: "100%" }}
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap"></div>
          <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0">
            <Breadcrumb
              links={[
              { label: "Home", href: "/dashboard", isActive: false },
              { label: "Jobs List", href: "/job/list", isActive: false },
              { label: "Job Detail", href: "", isActive: true },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="mx-xl-4 mt-9">
        <div className="card">
          <div className="card-header cursor-pointer border-bottom-0 py-4">
            <div className="card-title m-0">
              <h3 className="fw-semibold m-0">Job Details - {logjob.uuid}</h3>
            </div>
            {logjob.status !== "COMPLETED" ? (
<>
              <button  data-bs-toggle="tooltip" title="Click here to edit job"
              onClick={() => {setEditJobModal(true)}}
              className="btn btn-secondary btn px-5 py-3 m-1">
               <i className="fa fa-pencil fs-4" ></i>
              </button>
             
              </>
            ) : (
              ""
            )}
          </div>
        
          {editJobModal && (
             <EditJobModal  editJobModal={editJobModal}  
             handleCloseJob={handleCloseJob}
             currentJobId={currentJobId}
             />
          )}
         
        </div>

        <div className="mt-1 row g-6  g-xl-9">
          <div className="col-xl-6 col-lg-6 col-md-6 col-12">
            <div className="card">
              <div className="card-body d-flex flex-column px-9 pt-8 pb-8 ">
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Job Type
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {_.capitalize(_.lowerCase(logjob.jobType ?? ""))}
                    </span>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Created By
                  </label>
                  <div className="col-lg-6">
                    <span className="fs-4 text-dark">
                      {logjob.createdBy?.firstName ?? ""}
                    </span>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Location Name
                  </label>
                  <div className="col-lg-6 fv-row">
                    <Link to={`/locations/list/history/${logjob.locationId}`} className="text-hover-primary">
                    <div  className="d-flex align-items-center cursor-pointer">
                    <IconPickerItem icon={logjob?.location?.servicePlan?.indicater} size={20} color="#ffc700" />
                     <span className="text-primary fs-4">{logjob?.location?.name}</span>
                     <IconPickerItem icon={logjob?.location?.servicePlan?.indicater} size={20} color="#ffc700" />
                    <i className="fa fa-external-link ms-3"></i>
                    </div>
                      
                    </Link>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Start Time
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {logjob.dateAndTime
                        ? Moment.unix(logjob.dateAndTime / 1000)
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                        : ""}
                    </span>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    End Time
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {logjob.closingDateAndTime
                        ? Moment.unix(logjob.closingDateAndTime / 1000)
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                        : ""}
                    </span>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Status
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {_.capitalize(_.lowerCase(logjob.status ?? ""))}
                    </span>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fw-semibold text-muted fs-5">
                    Comments
                  </label>
                  <div className="col-lg-6 fv-row">
                      <span className="fs-5 text-muted ">Category: </span>
                      <span className="text-dark">
                      {categoriesDB?.find((c) => c.id === logjob?.additionalNoteCategoryId)?.name || logjob?.additionalNoteCategoryId || '-'}
                      </span>
                  <div>
                  <span className="fs-5 text-muted ">Note: </span>
                  <span className="text-dark">
                    {logjob?.additionalComments || '-'}
                  </span>
                </div>
                </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Cleanliness
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {_.capitalize(_.lowerCase(logjob.cleanliness ?? ""))}
                    </span>
                  </div>
                </div>
                <div className="row ">
                  <label className="col-lg-6 fw-semibold text-muted fs-5">
                    Action Items
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="fs-5 text-muted">Category: </span>
                  <span className="text-dark">
                  {categoriesDB?.find((c) => c.id === logjob?.additionalNoteCategoryId)?.name || logjob?.additionalNoteCategoryId || '-'}
                  </span>
                  <div>
                <span className="fs-5 text-muted">Note: </span>
                  <span className="text-dark">
                    {logjob?.additionalComments || '-'}
                  </span>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-6 col-lg-6 col-md-6 col-12">
            <div className="card">
              <div className="card-body d-flex flex-column px-9 pt-8 pb-8 ">
                
               
               
               
              <div className="row mb-4  ">
                    <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Traveling Start Time
                    </label>
                    <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      
                      {logjob.travelingStartTime
                        ? Moment.utc(logjob?.travelingStartTime)
                        .local()
                        .format("YYYY-MM-DD HH:mm:ss") : ""}
                    </span>
                    </div>
                 </div>
                <div className="row mb-4  ">
                    <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Traveling End Time
                    </label>
                    <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                    {logjob?.travelingEndTime ? Moment.utc(logjob?.travelingEndTime)
                    .local()
                    .format("YYYY-MM-DD HH:mm:ss") : ""}

                    </span>
                    </div>
                 </div>
                 <div className="row mb-4  ">
                    <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Traveling Duration 
                    </label>
                    <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      
                      {travelingDuration(logjob.travelingStartTime, logjob.travelingEndTime)}
                    </span>
                    </div>
                 </div>
                 <div className="row mb-4">
                    <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Work Start Time
                    </label>
                    <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                    {logjob?.workStartTime ? Moment.utc(logjob?.workStartTime)
                    .local()
                    .format("YYYY-MM-DD HH:mm:ss") : ""}

                    </span>
                    </div>
                 </div>
                 <div className="row mb-4">
                    <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Work Duration  
                    </label>
                    <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      
                      {travelingDuration(startTime, endTime)}
                    </span>
                    </div>
                 </div>
                 <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Customer Satisfaction
                  </label>
                  <div className="col-lg-6">
                    <span className="fs-5 text-dark">
                      {_.capitalize(
                        _.lowerCase(logjob.customerSatisfaction ?? "")
                      )}
                    </span>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                    Traffic Rate
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {_.capitalize(_.lowerCase(logjob.trafficRate ?? ""))}
                    </span>
                  </div>
                </div>
                <div className="row mb-4">
                  <label className="col-lg-6 fw-semibold text-muted fs-5">
                    Staff Enthusiasm
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {_.capitalize(_.lowerCase(logjob.staffEnthusiasm ?? ""))}
                    </span>
                  </div>
                </div>
                <div className="row ">
                  <label className="col-lg-6 fw-semibold text-muted fs-5">
                    Status Of Sanitizer
                  </label>
                  <div className="col-lg-6 fv-row">
                    <span className="text-dark fs-5">
                      {_.capitalize(_.lowerCase(logjob.sanitizerStatus ?? ""))}
                    </span>
                  </div>
                </div>
            </div>
          </div>
        </div>

        <div className="mt-1 row g-6  g-xl-9">
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
              <div className="card">
                <div className="card-header">
                      <div className="card-title">
                      Marketing Materials Used
                      </div>
                </div>
                <div className="card-body">
                {logjob.marketingMaterials?.length > 0
                      ? logjob.marketingMaterials?.map((element: any) => {
                          return (
                            <li className="fs-5 text-dark">{element.name}</li>
                          );
                        })
                      : <span className="text-muted">No marketing materials available</span>}
                      
                </div>
              </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <div className="card">
                <div className="card-header">
                      <div className="card-title">
                      Operations
                      </div>
                </div>
                  <div className="card-body">
                  {logjob.operations?.length > 0
                        ? logjob.operations?.map((element: any) => {
                            return (
                              <li className="fs-5 text-dark">{element.name}</li>
                            );
                          })
                        : <span className="text-muted">No operations available</span>}
                  </div>
                </div>
                </div>
        </div>
        <div className="mt-1 row g-6 g-xl-9">
            <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                  {logjob?.tickets?.length ? (
                    logjob.tickets.map((ticket: any, index: number) => (
                      <div className="card" key={`ticket-${index}`}>
                          <div className="card-body d-flex flex-column px-9 pt-8 pb-8">
                              <div key={index} className="mb-4">
                                <label className="col-lg-6 fs-4 fw-semibold ">Ticket - {index+1}</label>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Ticket Id
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <Link
                                      to={`/tickets/list/viewticket/${ticket?.id}`}
                                      className="text-hover-primary"
                                    >
                                      <span className="text-primary fs-4">
                                        {ticket.uuid}{" "}
                                      </span>
                                      <i className="fa fa-external-link ms-3"></i>
                                    </Link>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Machine Name
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <Link
                                      to={`/tickets/list/viewticket/${ticket?.machine?.id}`}
                                      className="text-hover-primary"
                                    >
                                      <span className="text-primary fs-4">
                                        {ticket?.machine?.name}{" "}
                                      </span>
                                      <i className="fa fa-external-link ms-3"></i>
                                    </Link>
                                  </div>
                                </div>

                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Serial Number
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <Link
                                      to={`/tickets/list/viewticket/${ticket?.machine?.id}`}
                                      className="text-hover-primary"
                                    >
                                      <span className="text-primary fs-4">
                                        {ticket?.machine?.serialNumber}{" "}
                                      </span>
                                      <i className="fa fa-external-link ms-3"></i>
                                    </Link>
                                  </div>
                                </div>

                                {/* Issue Reported */}
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Issue Reported
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    {ticket.issuesReported?.length ? (
                                      <ul className="text-dark fs-5">
                                        {ticket.issuesReported.map(
                                          (issue: any, issueIndex: number) => (
                                            <li key={issueIndex}>{issue.name}</li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      <span className="text-dark fs-5">
                                        No issues reported
                                      </span>
                                    )}
                                  </div>
                                </div>

                                {/* Diagnosis Done */}
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Diagnosis Done
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    {ticket.diagnosisDone?.length ? (
                                      <ul className="text-dark fs-5">
                                        {ticket.diagnosisDone.map(
                                          (diagnosis: any, diagnosisIndex: number) => (
                                            <li key={diagnosisIndex}>
                                              {diagnosis.name}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      <span className="text-dark fs-5">
                                        No Diagnosis Done
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Machine Service Done
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    {ticket.machineServicesDone?.length ? (
                                      <ul className="text-dark fs-5">
                                        {ticket.machineServicesDone.map(
                                          (service: any, serviceIndex: number) => (
                                            <li key={serviceIndex}>
                                              {service.name}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      <span className="text-dark fs-5">
                                        No Machine Service Done
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                       </div>
                    ))
                  ) : (
                    <p className="text-muted">No tickets available</p>
                  )}
                
            </div>
            
                  {logjob?.machineChecks?.length > 0 ? (
                    logjob.machineChecks.map((machineCheck: any, index: number) => (
                      <div className="col-xl-6 col-lg-6 col-md-6 col-12" key={index}>
                      <div className="card mb-4" >
                          <div className="card-body d-flex flex-column px-9 pt-8 pb-8 ">
                              <div key={index}>
                                        <label className="col-lg-6 fs-4 fw-semibold ">
                                    Machine's Checks
                                  </label>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5  text-muted">
                                    Machine Name
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                  <Link to={`/machines/list/history/${machineCheck.machineId}`} className="text-hover-primary">
                                    <span className="text-primary fs-4"> {machineCheck.machineName}</span>
                                    <i className="fa fa-external-link ms-3"></i>
                                  </Link>
                                </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5  text-muted">
                                    Serial Number
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5 fw-semibold">
                                      {machineCheck.serialNumber}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5  text-muted">
                                    Blender
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fw-semibold fs-5">
                                      {machineCheck?.blenderName}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    TubeDoor Shield
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                    {machineCheck?.tubeShieldName}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                   Cup Holder
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                    {machineCheck?.cupHolderName}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Cleanliness Check
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail?.cleanlinessCheck === true
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Flowmeter Activated
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail?.flowmeterActivated ===
                                      true
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Get Status Passed
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail?.getStatusPassed === true
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Has Polyfuses
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail?.hasPolyfuses === true
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Made 4 Smoothies
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail?.made4Smoothies === true
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Sanitizer Level
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail?.sanitizerLevel
                                        ? machineCheck?.checksDetail?.sanitizerLevel
                                        : "-"}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Water Level Calibrated With Scale
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail
                                        ?.waterLevelCalibratedWithScale === true
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </div>
                                </div>

                                <div className="row mb-2">
                                  <label className="col-lg-6 fs-5 fw-semibold text-muted">
                                    Replace Machine
                                  </label>
                                  <div className="col-lg-6 fv-row">
                                    <span className="text-dark fs-5">
                                      {machineCheck?.checksDetail
                                        ?.replaceMachine === true
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                        </div>
                    ))
                  ) : (
                    <p className="text-muted">No machine checks available</p>
                  )}
           
          </div>
          </div>


        <div className="mt-1 row g-6  g-xl-9">
          <div className="col-xl-6 col-lg-12 col-md-12 col-12 mt-2 pt-2">
            
                <div className="card">
                  <div className="card-body">
                    <div className="btn-bg-light btn fs-2 fw-semibold text-start mb-2 border-0">
                      Job Images
                    </div>

                    <div className="rounded-1 mt-2 h-100 shadow-none">
                      <div className="row align-items-center">
                      {logjob.uploadImagesOrVideos?.length > 0 ? 
                        logjob.uploadImagesOrVideos?.map(
                          (image: any, index: any) => {
                            return (
                              <>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12 mt-4 pt-2">
                                  {image["type"] === "image/png" ||
                                  image["type"] === "image/jpeg" ||
                                  image["type"] === "image/webp" ||
                                  image["type"] === "image/jpg" ? (
                                    <SlideshowLightbox className="container grid grid-cols-3 gap-2 mx-auto">
                                      <img
                                        src={image["url"]}
                                        key={image}
                                        alt="Images"
                                        width="250"
                                        className="img-view img-fluid position-relative overflow-hidden rounded-1 p-2 bg-light mt-2"
                                      />
                                    </SlideshowLightbox>
                                  ) : (
                                    <video
                                      controls
                                      src={image["url"]}
                                      className="img-view img-fluid position-relative overflow-hidden rounded-1 p-2 bg-light mt-2"
                                      width="250"
                                    />
                                  )}
                                </div>
                              </>
                            );
                          }
                        ) : 
                        <span className="text-muted">No job images available</span>}
                      </div>
                    </div>
                  </div>
                </div>
          </div>
          
              
                <div className="col-xl-6 col-lg-12 col-md-12 col-12 mt-2 pt-2">
                  <div className="card">
                    <div className="card-body">
                      <div className="btn-bg-light btn fs-2 fw-semibold text-start mb-2 border-0">
                        Setup Images
                      </div>

                      <div className="rounded-1 mt-2 h-100 shadow-none">
                        <div className="row align-items-center">
                        {logjob.attachments?.smoothieSetupMedia?.length > 0 ?
                          logjob.attachments?.smoothieSetupMedia?.map((image: any, index: any) => {
                            return (
                              <>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12 mt-4 pt-2" key={`smoothieSetupMedia-${index}`}>
                                  {image["type"] === "image/png" ||
                                  image["type"] === "image/jpeg" ||
                                  image["type"] === "image/webp" ||
                                  image["type"] === "image/jpg" ? (
                                    <SlideshowLightbox className="container grid grid-cols-3 gap-2 mx-auto">
                                      <img
                                        src={image["url"]}
                                        key={image["url"]}
                                        alt="Images"
                                        width="250"
                                        className="img-view img-fluid position-relative overflow-hidden rounded-1 p-2 bg-light mt-2"
                                      />
                                    </SlideshowLightbox>
                                  ) : (
                                    <video
                                      controls
                                      src={image["url"]}
                                      className="img-view img-fluid position-relative overflow-hidden rounded-1 p-2 bg-light mt-2"
                                      width="250"
                                    />
                                  )}
                                </div>
                              </>
                            );
                          }) 
                          : <span className="text-muted">No setup images available</span>}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
               


                <div className="col-xl-6 col-lg-12 col-md-12 col-12 mt-2 pt-2">
                  <div className="card">
                    <div className="card-body">
                      <div className="btn-bg-light btn fs-2 fw-semibold text-start mb-2 border-0">
                        Marketing Materials present
                      </div>

                      <div className="rounded-1 mt-2 h-100 shadow-none">
                        <div className="row align-items-center">
                        {logjob.attachments?.marketingMaterialPresent?.length > 0 ?
                          logjob.attachments?.marketingMaterialPresent?.map((image: any, index: any) => {
                            return (
                              <>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12 mt-4 pt-2" key={`marketingMaterial-${index}`}>
                                  {image["type"] === "image/png" ||
                                  image["type"] === "image/jpeg" ||
                                  image["type"] === "image/webp" ||
                                  image["type"] === "image/jpg" ? (
                                    <SlideshowLightbox className="container grid grid-cols-3 gap-2 mx-auto">
                                      <img
                                        src={image["url"]}
                                        key={image["url"]}
                                        alt="Images"
                                        width="250"
                                        className="img-view img-fluid position-relative overflow-hidden rounded-1 p-2 bg-light mt-2"
                                      />
                                    </SlideshowLightbox>
                                  ) : (
                                    <video
                                      controls
                                      src={image["url"]}
                                      className="img-view img-fluid position-relative overflow-hidden rounded-1 p-2 bg-light mt-2"
                                      width="250"
                                    />
                                  )}
                                </div>
                              </>
                            );
                          })
                          : <span className="text-muted">No marketing materials available</span>}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
             
        </div>
      </div>
    </div>
    <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
    </Suspense>
  );
};
